import theme from './theme';
import GlobalStyle from './GlobalStyle';
import mixins from './mixins';
import media from './media';
import Header from './Header';
import Main from './Main';
import Section from './Section';
import Footer from './Footer';
import Heading from './Heading';
import Button from './Button';
import InlineLink from './InlineLink';

export {
  theme,
  GlobalStyle,
  mixins,
  media,
  Header,
  Main,
  Section,
  Footer,
  Heading,
  Button,
  InlineLink,
};
